<template>
  <div v-if="!haveToken" class="login-form-container">
    <div class="container login-form">
      <div class="row">
        <div class="col-12 mt-2">
          <div class="position-relative">
            <b-form-input class="email-input mb-3 pl-5" v-model="email" placeholder="Email"></b-form-input>
            <i class="fa fa-envelope email-icon"/>
          </div>
          <div class="position-relative">
            <b-form-input class="password-input mt-0 pl-5" type="password" v-model="password" placeholder="Password"  @keyup.enter="signIn"></b-form-input>
            <i class="fa fa-lock password-icon"/>
          </div>
        </div>
        <div class="col-12 mt-4">
          <b-button class="w-100 sign-in-button" variant="primary" @click="signIn">Sign in</b-button>
        </div>
        <div v-if="errorMessage" class="col-12 font-weight-bolder text-center mt-4 text-danger">{{errorMessage}}</div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Authentication from '@/services/AuthenticationService'
// import GeneralService from '@/services/CateringService'
import DAH from '../lib/dataAccessHelpers'
import axios from "axios"

export default {
  name: 'login',
  data () {
    return {
      haveToken   : true,
      email       : "",
      password    : "",
      errorMessage: ""
    }
  },
  async mounted () {
    // if we have a token, verify it to be valid - if valid, then replace the one we have
    // with the new one we just got back and skip the login questions
    // then if/when we get the new token, replace it
    let token = this.getAccessToken();
    if( token ) {
      try {
        this.setAccessToken(token); // also sets up axios
        let response = await Authentication.authorize();
        if( response.status === 200 ) {
          let token = response.data[ 'x-access-token'];
          this.setAccessToken(token);
         // localStorage.removeItem( "categories" );
         // await this.getCategories();
          return this.home();
        } else {
          this.errorMessage = response.data.message;                // oops, the token ain't no good -- let's drop the user at login to start over.
          this.removeAccessToken();
        }
      } catch( error ) {
        console.log( error );
        this.errorMessage = error.message
      }
    }

    this.haveToken = false;

  },
  methods: {
    // this is our "home" screen
    home() {
      this.$router.push( { name: 'cateringHomeScreen' });
    },
    getAccessToken() {
      let token = localStorage.getItem('x-access-token');
      return token;
    },
    setAccessToken( token ) {
      localStorage.setItem( 'x-access-token',token);
    },
    removeAccessToken() {
      localStorage.removeItem('x-access-token');
    },
    // fixme: make global just like getPosConfig()
    // todo: and also get the items under the categories while we're in here
    // async getCategories() {
    //   return await DAH.getCategories();
    // },
    async signIn () {

      if( this.email.length === 0 || this.password.length === 0) {
        this.errorMessage = "Please enter email and password"
        return
      }

      let credentials = {
        'email': this.email,
        'password': this.password
      }

      try {
        let response = await Authentication.login(credentials)
        // console.log('login', response.data)

        if( response.status === 200 ) {

          let userData = response.data;
          let token    = userData[ 'x-access-token'];

          this.setAccessToken(token);
          delete userData[ 'x-access-token'];

          localStorage.setItem( 'user' , JSON.stringify(userData))
          localStorage.removeItem( "categories" );
          // await this.getCategories();   
        
          this.home();
        //   this.$store.dispatch('userLogIn', true)
        } else {
          this.errorMessage = response.data.message;
        }

      } catch( err ) {
        this.errorMessage = err.message;
      }

    }
  }
}
</script>

<style lang="scss" scoped>
.login-form-container{
  height: 100vh;
  background: -moz-linear-gradient(top,  rgba(101,157,189,1)  0%, rgba(101,157,189,0.9) 52%, rgba(213,222,229,1) 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(top,  rgba(101,157,189,1) 0%,rgba(101,157,189,0.9) 52%,rgba(213,222,229,1) 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to bottom,  rgba(101,157,189,1) 0%,rgba(101,157,189,0.9) 52%,rgba(213,222,229,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#659dbd', endColorstr='#d5dee5',GradientType=0 ); /* IE6-9 */
  .login-form {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) !important;
    max-width: 400px;
    overflow: auto;
    h3 {
      color: white;
      // todo: center this
    }

    p {
      color: white;
      // todo: center this
    }

    .login-logo {
      border-radius:1em;
      margin-left:auto;
      margin-right:auto;
      margin-top:0;
      margin-bottom:1em;
    }

    .email-input{
      border-radius: 3.25rem !important;
      height: calc(1.5em + 1.75rem + 2px) !important;
      border-bottom: 0;
    }
    .password-input{
      border-radius: 3.25rem !important;
      height: calc(1.5em + 1.75rem + 2px) !important;
    }
    .sign-in-button{
      height: calc(1.5em + 1.75rem + 2px) !important;
      border-radius: 3.25rem !important;
      background-color: #659DBD;
      border: #659DBD;
    }
    .sign-in-button.btn-primary:hover{
      background-color: #659DBD;
      border-color: #659DBD;
    }
    .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
        color: #fff;
        background-color: #659DBD;
        border-color: #659DBD;
    }
    .email-icon{
      position: absolute;
      top: 17px;
      left: 20px;
      font-size: 19px;
    }
    .password-icon{
      position: absolute;
      top: 15px;
      left: 20px;
      font-size: 19px;
    }
  }
}
</style>
